export default __webpack_public_path__ + "static/media/hks4.66fa58ea.jpg";